import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    professors: [],
    professor: {},
    access_token: localStorage.getItem('access_token')
  },
  mutations: {
    index(state, payload) {
      state.professors = payload
    },
    show(state, payload) {
      payload.all_doyangs = state.professor.all_doyangs ? state.professor.all_doyangs : []
      state.professor = payload
    }
  },
  actions: {
    index({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/users${payload ? payload : ''}`).then((res) => {
        commit('index', res.data)
        return res.data
      })
    },
    show({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/users/${payload}`).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    create({ commit }, payload) {
      return axios.post(`${ENV.API_URL}/api/users`, payload).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    update({ commit }, payload) {
      return axios.put(`${ENV.API_URL}/api/users/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
        return res.data
      })
    }
  },
  getters: {
    professors: state => {
      return state.professors
    },
    professor: state => {
      return state.professor
    },
    certifiedProfessors: state => {
      return state.professors.filter( user => user.certifier )
    },
  },
  modules: {
  }
}
